import { useContext } from 'react';
import { Formik } from 'formik';
import { DatePicker, FilterModal, SelectSearch } from 'components';
import { DateConvert } from 'utilities';
import { DropdownPermintaanProduksiContext } from '../Context';

export const ModalFilterPermintaanProduksi = ({
  show,
  setShow,
  filter,
  setFilter,
  showStatusApprovalFilter = false,
}) => {
  const { dropdownApproval, dropdownJobOrder } = useContext(
    DropdownPermintaanProduksiContext
  );
  const defaultDropdown = { value: null, label: 'Semua' };
  const optItems = [defaultDropdown].concat(dropdownJobOrder?.data ?? []);
  const optApproval = [defaultDropdown].concat(dropdownApproval);

  const initialValues = {
    tgl_permintaan_produksi_start: filter?.tgl_permintaan_produksi_start,
    tgl_permintaan_produksi_end: filter?.tgl_permintaan_produksi_end,
    tgl_job_order_start: filter?.tgl_job_order_start,
    tgl_job_order_end: filter?.tgl_job_order_end,
    id_barang_jadi: filter?.id_barang_jadi,
    status_approval: filter?.status_approval,
  };

  const onSubmit = (values) => {
    const checkActive =
      !!Object.values(values).filter((val) => val !== undefined).length > 0;

    if (checkActive) {
      setFilter((prev) => ({
        ...prev,
        ...values,
        active: true,
        page: '1',
      }));

      setShow(false);
      return;
    }

    setFilter({ ...values, filter: false });
    setShow(false);
  };

  const onResetButtonClick = () => {
    setFilter((prev) => ({
      ...prev,
      page: '1',
      active: false,
      tgl_permintaan_produksi_start: undefined,
      tgl_permintaan_produksi_end: undefined,
      tgl_job_order_start: undefined,
      tgl_job_order_end: undefined,
      id_barang_jadi: undefined,
      status_approval: undefined,
    }));
    setShow(false);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={onSubmit}
    >
      {({ values, setFieldValue, handleSubmit, setValues }) => (
        <FilterModal
          show={show}
          setShow={setShow}
          onResetButtonClick={() => onResetButtonClick(setValues)}
          onFilterButtonClick={handleSubmit}
        >
          <DatePicker
            selectsRange
            label="Tgl. Permintaan Produksi"
            placeholderText="Pilih Tanggal Permintaan Produksi"
            startDate={
              values.tgl_permintaan_produksi_start
                ? new Date(values.tgl_permintaan_produksi_start)
                : ''
            }
            endDate={
              values.tgl_permintaan_produksi_end
                ? new Date(values.tgl_permintaan_produksi_end)
                : ''
            }
            onChange={(dates) => {
              const [start, end] = dates;
              const startDate = start ? DateConvert(start).default : null;
              const endDate = end ? DateConvert(end).default : null;

              setFieldValue('tgl_permintaan_produksi_start', startDate);
              setFieldValue('tgl_permintaan_produksi_end', endDate);
            }}
            monthsShown={2}
          />

          <DatePicker
            selectsRange
            label="Tgl. Job Order"
            placeholderText="Pilih Tanggal Job Order"
            startDate={
              values.tgl_job_order_start
                ? new Date(values.tgl_job_order_start)
                : ''
            }
            endDate={
              values.tgl_job_order_end ? new Date(values.tgl_job_order_end) : ''
            }
            onChange={(dates) => {
              const [start, end] = dates;
              const startDate = start ? DateConvert(start).default : null;
              const endDate = end ? DateConvert(end).default : null;

              setFieldValue('tgl_job_order_start', startDate);
              setFieldValue('tgl_job_order_end', endDate);
            }}
            monthsShown={2}
          />

          <SelectSearch
            label="Item Job Order"
            placeholder="Pilih Item Job Order"
            loading={dropdownJobOrder.isLoading}
            option={optItems}
            defaultValue={
              values.id_barang_jadi
                ? optItems?.find((v) => values.id_barang_jadi === v.value)
                : defaultDropdown
            }
            onChange={({ value }) => setFieldValue('id_barang_jadi', value)}
          />

          {showStatusApprovalFilter && (
            <SelectSearch
              label="Status Approval"
              placeholder="Pilih Status Approval"
              option={optApproval}
              defaultValue={
                values.status_approval
                  ? optApproval.find((v) => values.status_approval === v.value)
                  : defaultDropdown
              }
              onChange={({ value }) => setFieldValue('status_approval', value)}
            />
          )}
        </FilterModal>
      )}
    </Formik>
  );
};
